import {
    GET_RECENT_MOVIES_SUCCEEDED,
    GET_SOON_IN_CINEMA_MOVIES_SUCCEEDED,
    GET_SOON_MOVIES_SUCCEEDED,
    GET_MOVIE_DETAILS_SUCCEEDED,
    GET_MOVIE_TIME_SCHEDULE_SUCCEEDED,
    GET_ALL_MOVIES_SUCCEEDED,
    GET_ALL_MOVIES_SEE_MORE_SUCCEEDED,
    GET_RECENT_MOVIES_PAGE_SUCCEEDED,
    GET_RECENT_MOVIES_PAGE_SEE_MORE_SUCCEEDED, 
    GET_SOON_IN_CINEMA_FILTERED_MOVIES_SUCCEEDED,
    GET_MOVIES_SCHEDULE_SUCCEEDED,
    GET_RECENT_MOVIES_SLIDER_SUCCEEDED,
    GET_RECOMMENDED_MOVIES_SUCCEEDED,
} from '../actions/types';

const initialState = {
    soonMovies: [],
    recentMovies: [],
    movieDetails: {},
    soonMoviesFiltered: [],
    movieTimeScheduler: [],
    allMovies: {},
    recentMoviesPage: {},
    recentMoviesFiltered: [],
    movieSchedule: [],
    recentMoviesSlider: [],
    recommendedMovies: [],
    filteredMovieSchedule: []
}

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_SOON_MOVIES_SUCCEEDED:
            return {
                ...state,
                soonMovies: action.payload.rows
            };

        case GET_RECENT_MOVIES_SUCCEEDED:
            return {
                ...state,
                recentMovies: action.payload
            };
        case GET_MOVIE_DETAILS_SUCCEEDED:
            return {
                ...state,
                movieDetails: action.payload
            };

        case GET_SOON_IN_CINEMA_MOVIES_SUCCEEDED:
            return {
                ...state,
                soonMoviesFiltered: action.payload.rows
            };
        case GET_MOVIE_TIME_SCHEDULE_SUCCEEDED:
            return {
                ...state,
                movieTimeScheduler: action.payload
            }
        case GET_ALL_MOVIES_SUCCEEDED:
            return {
                ...state,
                allMovies:action.payload
            }
        case GET_ALL_MOVIES_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                allMovies: action.payload
            }
        case GET_RECENT_MOVIES_PAGE_SUCCEEDED:
            return {
                ...state,
                recentMoviesPage: action.payload
            }
        case GET_RECENT_MOVIES_PAGE_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                recentMoviesPage: action.payload
            }
        case GET_SOON_IN_CINEMA_FILTERED_MOVIES_SUCCEEDED:
            return {
                ...state,
                recentMoviesFiltered: action.payload
            }
        case GET_MOVIES_SCHEDULE_SUCCEEDED:
            return {
                ...state,
                movieSchedule: action.payload
            }
        case GET_RECENT_MOVIES_SLIDER_SUCCEEDED:
            return {
                ...state,
                recentMoviesSlider: action.payload
            }
        case GET_RECOMMENDED_MOVIES_SUCCEEDED: 
            return {
                ...state,
                recommendedMovies: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/SHARED/reducers/movies.reducer.js